module.exports = __webpack_public_path__ + "static/img/1-1.b8986c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mobile/joinUs/1-1.png
// module id = YdJQ
// module chunks = 15